import { api } from "@/lib/api";

// La API necesita el token de autenticación (va por cabecera, no por cookie), así que no se puede
// descargar con un <a href> normal — hay que pedirlo por axios (que ya añade el token) como blob y
// simular el click de descarga nosotros mismos.
export async function downloadExcel(url: string, filename: string): Promise<void> {
  const res = await api.get(url, { responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
}
